import * as t from "./types";
import { State } from "./reducer";

export const getMessages = (state: State): t.Message[] => state.messages;
